import React from "react";

export const NifflerSvg = (props) => {
  switch (props.Icon) {
    case "Board" : 
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={props.class_Icon}  
                viewBox="0 0 24 24"
              >
                <g stroke="none" strokeWidth="1">
                  <g>
                    <path d="M11.499 9.5 11.5 21H6.25a3.25 3.25 0 0 1-3.245-3.065L3 17.752V9.499zm1.5 6H21.5v2.252a3.25 3.25 0 0 1-3.25 3.25H13zm5.252-13.002a3.25 3.25 0 0 1 3.245 3.066l.005.184L21.5 14h-8.501L13 2.5zm-6.751 0L11.499 8H3V5.75a3.25 3.25 0 0 1 3.25-3.25z"></path>
                  </g>
                </g>
              </svg>
            )

            case "Table" :
              return(

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlSpace="preserve"
                 
                  fillRule="evenodd"
                  strokeLinejoin="round"
                  strokeMiterlimit="2"
                  clipRule="evenodd"
                  viewBox="0 0 32 32"
                >
        <path d="M29 23h-8v6h3a5 5 0 0 0 3.536-1.464A5 5 0 0 0 29 24zm-10 6h-6v-6h6zM3 23v1c0 1.326.527 2.598 1.464 3.536A5 5 0 0 0 8 29h3v-6zm8-6v4H3v-4zm8 0v4h-6v-4zm10 0v4h-8v-4zm-18-2H3v-4h8zm8 0h-6v-4h6zm10 0h-8v-4h8zM3 9h26V8a5 5 0 0 0-1.464-3.536A5 5 0 0 0 24 3H8a5 5 0 0 0-3.536 1.464A5 5 0 0 0 3 8z"></path>
    </svg>
    )


      case "AddUser" :
              return(
            <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M2 21h8a1 1 0 0 0 0-2H3.071A7.01 7.01 0 0 1 10 13a5.044 5.044 0 1 0-3.377-1.337A9.01 9.01 0 0 0 1 20a1 1 0 0 0 1 1m8-16a3 3 0 1 1-3 3 3 3 0 0 1 3-3m13 11a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 1 1"></path>
        </svg>
              )
      default:
        return (
          <svg
            className={props.class_Icon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 323.35 324.14"
          >
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <path d="M85.67 167.78c11.46-11.7 23.12-23.58 34.76-35.49 4.15-4.24 8.62-6.81 14.46-3.06 7 4.48 7.53 11.3.83 18-11.81 11.79-23.93 23.25-35.57 34.51l41.29 40.78c10.92-11 22.55-22.85 34.39-34.51 6.9-6.79 13.45-6.6 18.13.14 4.27 6.17 1.3 10.86-3.19 15.27-11.65 11.46-23.28 23-34.76 34.29 10.11 14.86 10.11 14.86-1.91 26.87q-4.71 4.71-9.42 9.41c-25.59 25.45-53.14 30-85.84 14.09-.89-.43-1.87-.67-4.17-1.48l-35 37.55L0 304.52l35.46-33.29c-3.5-14.79-7.62-26.43-8.76-38.35-1.91-20.16 6-37.35 20.26-51.6q6.16-6.15 12.31-12.32c11.86-11.85 11.86-11.85 26.4-1.18ZM267.71 38l35.77-38 19.87 20.11c-10.19 9.76-20.6 20-31.39 29.9-4.65 4.25-5.74 7.49-2.6 13.79 13.3 26.62 8.35 56.13-12.18 77.6-6.14 6.42-12.55 12.57-18.82 18.86-5.35 5.37-10.6 5.33-16 0-26.31-26.34-52.82-52.48-78.73-79.19-2.67-2.75-4.2-11-2.29-13.11 15.4-16.71 29.81-35.06 54.26-39.72 18.32-3.54 35.18.11 52.11 9.76Z" />
              </g>
            </g>
          </svg>
        );
    }
  };